/* globals FontFaceObserver */

$(function () {
	'use strict';

	var aktivGrotesk = new FontFaceObserver('Aktiv Grotesk');

	Promise.all([
		aktivGrotesk.load()
		// --> Include future fonts here <--
	]).then(function(){
		document.documentElement.classList.add('fonts-loaded');
	});
});